<template> 
<div class="pt430" id="pt430">
    <!--パンくず-->
    <breadcrumb :navListCustom="[{title:'マイページ', routerName: pt430Init.myPage , param: {pageNo: '81'}}, {title:$t('pt430.labels.title'), routerName: '', param: {}}]"></breadcrumb>
    <div class="searchCondition">
        <!--マイページタイトル-->
        <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
        <div class="">
            <!--購入履歴タイトル-->
            <div class="itemTitle">
                <h3>{{$t('pt430.labels.title')}}</h3>
            </div>
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt430'"/>
            <div id="warming">
                <p class="warmingMessage"></p>
            </div>
                <div v-if="pageFeedData.totalRecord > 0">
                    <div class="topBtn">
                        <!-- 注文 -->
                        <a @click="pt430search(1)"><span>{{$t('pt430.labels.order')}}</span></a>
                        <!-- キャンセル注文 -->
                        <a @click="pt430search(3)"><span>{{$t('pt430.labels.cancel')}}</span></a>
                    </div>
                    <br>
                    <br>
                    <select v-model="reqModel.rirekiKbn" name="rirekiKbn" id="_rirekiKbnList" class="rirekiKbn" @change="changeRirekiKbn(reqModel.rirekiKbn);">
                        <option v-for="(item, index) in pt430Init.rirekiKbnList" :key="index" :value="item.KEY" >
                            {{item.VALUE}}
                        </option>
                    </select>
                    <div class="totalRecord">
                        <span v-if="reqModel.searchKbn == '1'">に確定された{{reqModel.totalRecord}}件の注文</span>
                        <span v-if="reqModel.searchKbn == '3'">にキャンセルされた{{reqModel.totalRecord}}件の注文</span>
                    </div>
                    <br>
                    <br>
                </div>
                <!-- 検索結果に一致する注文がない場合 -->
                <div v-if="noResult" class="noResultMessage" >
                    <span class="noResultMessage">
                        <!-- 検索条件に一致する注文がありませんでした。 -->
                        {{$t('pt430.labels.messgNoResult')}}
                    </span>
                </div>
                <!-- ページャー表示 -->
                <div class="searchList">
                    <page-feed v-if="isDisplay"
                        :isDisplay="isPagingDisplay"
                        :isDisplaySort="false"
                        :pageFeedData="pageFeedData"
                        :orderByType="ptOrderByType"
                        :dispPageSizeList="dispPageSizeList"
                        @search="changeSearch"
                        >
                        <template slot="TableRender">
                            <div class="floatRight">
                                <template v-if="isTuisekiLinkShow">
                                    <div v-if="pt430Init.tuisekiLinkUrl != '' && pt430Init.tuisekiLinkUrl != null">
                                        <a @click="selectTuisekiLink()">{{$t('pt430.labels.tuisekiLinkWord')}}</a>
                                    </div>
                                </template>
                            </div>
                            <table id="cart-history" class="searchListTable">
                                <thead>
                                    <!-- No. -->
                                    <th v-if="siteFlg == '1'" scope="col">{{$t('pt430.labels.no')}}</th>
                                    <!-- No. -->
                                    <th scope="col">{{$t('pt430.labels.no')}}</th>
                                    <!-- 届先 -->
                                    <th v-if="siteFlg == '1'" scope="col">{{$t('pt430.labels.destination')}}</th>
                                    <!-- ご注文日 -->
                                    <th scope="col">{{$t('pt430.labels.orderDate')}}</th>
                                    <!-- 購入日 -->
                                    <th v-if="pt430Init.storeDispFlg == 1">{{$t('pt430.labels.purchaseDate')}}</th>
                                    <!-- 注文番号 -->
                                    <th v-if="pt430Init.orderNoDispFlg == 1" scope="col">
                                        {{$t('pt430.labels.orderNo')}}
                                    </th>
                                    <!-- 注文区分 -->
                                    <th v-if="pt430Init.orderKbnFlg == 1" scope="col" >{{$t('pt430.labels.orderKbn')}}</th>
                                    <!-- 金額 -->
                                    <template v-if="pt430Init.amountDispFlg == 1 && pt430Init.priceShow != 1">
                                        <template v-if="pt430Init.syouhiZeiDispFlg == 0">
                                            <th scope="col">
                                                {{$t('pt460.labels.kingakuStr')}}
                                            </th>
                                        </template>
                                        <template v-else>
                                            <th scope="col">
                                                {{$t('pt460.labels.kingakuStr')}}{{$t('pt430.labels.taxincluded')}}
                                            </th>
                                        </template>
                                    </template>
                                    <!-- 支払い方法 -->
                                    <th scope="col">{{$t('pt430.labels.payment')}}</th>
                                    <!-- お支払い -->
                                    <th v-if="pt430Init.payDispFlg == 1" scope="col">
                                        {{$t('pt430.labels.pay')}}
                                    </th>
                                    <template v-if="pt430Init.syukkaKanriFlg == 0">
                                        <!-- 配送業者 -->
                                        <th v-if="pt430Init.transCoDispFlg == 1" scope="col">{{$t('pt430.labels.deliveryCompany')}}</th>
                                        <!-- 出荷日	 -->
                                        <th scope="col">{{$t('pt460.labels.shipDate')}}</th>
                                        <!-- お問い合わせ番号 -->
                                        <th v-if="pt430Init.toiNoDispFlg == 1" scope="col" >{{$t('pt430.labels.optionLabel')}}</th>
                                        <!-- 配送状況 -->
                                        <th v-if="pt430Init.shipStatus == 1" scope="col" >{{$t('pt430.labels.shipStatus')}}</th>
                                    </template>
                                    <!--担当者名-->
                                    <template v-if="pt430Init.tantoDispFlg == 1">
                                        <th scope="col">{{$t('pt430.labels.tanto')}}</th>
                                    </template>
                                    <!--店舗名-->
                                    <template v-if="pt430Init.storeDispFlg == 1">
                                        <th scope="col">{{$t('pt430.labels.store')}}</th>
                                    </template>
                                    <!-- 納品書出力 -->
                                    <template v-if="pt430Init.nohinsyoDispFlg == 1">
                                        <th scope="col">{{$t('pt430.labels.nohinsyo')}}</th>
                                    </template>
                                    <!-- 領収書出力 -->
                                    <template v-if="pt430Init.ryousyuusyoDispFlg == 1">
                                        <th scope="col">{{$t('pt430.labels.ryousyuusyo')}}</th>
                                    </template>
                                    <!-- 詳細 -->
                                    <th scope="col">{{$t('pt430.labels.details')}}</th> 
                                </thead>
                                <tbody>
                                    <tr v-for="(orders, index) in pt430Init.list" :key="index">
                                        <td v-if="siteFlg == '1'" >
                                            <span v-if="orders.GIFT_KBN =='1'">{{$t('pt460.labels.directDelivery')}}</span>
                                        </td>
                                        <!-- No. -->
                                        <td scope="row" aria-label="No.">
                                            {{pageFeedData.fromRecord+index}}
                                        </td>
                                        <!-- ご注文日 -->
                                        <td :aria-label="$t('pt430.labels.orderDate')">
                                            <span>{{orders.ORDER_YMD}}</span>
                                        </td>
                                        <!-- 購入日 -->
                                        <td v-if="pt430Init.storeDispFlg == 1" :aria-label="$t('pt430.labels.purchaseDate')">
                                            <span>{{orders.ORDER_YMD}}</span>
                                        </td>
                                        <!-- 注文番号 -->
                                        <td v-if="pt430Init.orderNoDispFlg == 1" :aria-label="$t('pt430.labels.orderNo')">
                                            <span>{{orders.ORDER_CD_TYPICAL}}</span>
                                        </td>
                                        <!-- 注文区分 -->
                                        <td v-if="pt430Init.orderKbnFlg == 1" :aria-label="$t('pt430.labels.orderKbn')">
                                            <span>{{orders.ORDER_KBN_NM}}</span>
                                        </td>
                                        <!-- 金額 -->
                                        <template v-if="pt430Init.amountDispFlg == 1 && pt430Init.priceShow != 1">
                                            <template v-if="pt430Init.syouhiZeiDispFlg == 0">
                                                <td :aria-label="$t('pt430.labels.kingakuStr')">
                                                    <input-number v-model="orders.SEIKYUU_ZEI_K_KIN" :readonly="true" :suffix ="'円'" />
                                                </td>
                                            </template>
                                            <template v-else>
                                                <td :aria-label="$t('pt430.labels.kingakuStrTax')">
                                                    <input-number v-model="orders.SEIKYUU_ZEI_K_KIN" :readonly="true" :suffix ="'円'" />
                                                </td>
                                            </template>
                                        </template>
                                        <!-- 支払い方法 -->
                                        <td :aria-label="$t('pt430.labels.payment')">
                                            <span>{{orders.KESSAI_NM}}</span>
                                        </td>
                                        <!-- 支払い -->
                                        <template v-if="pt430Init.payDispFlg == 1">
                                            <td :aria-label="$t('pt430.labels.pay')">
                                                <!--決済エラー-->
                                                <span v-if="orders.AUTH_NOT_FLG == '1' && orders.TEIKI_KBN == '1'">{{$t('pt430.labels.error')}}<br></span>
                                                <span v-else-if="orders.KESSAI_CD == '2' || orders.KESSAI_CD == '13' || orders.KESSAI_CD == '999'">{{$t('pt430.labels.hiphen')}}</span>
                                                <span v-else-if="orders.NYUKIN_K_FLG == '1'">{{$t('pt430.labels.paid')}}</span>
                                                <span v-else>{{$t('pt430.labels.check')}}</span>
                                                <span v-if="orders.AUTH_NOT_FLG == '1' && orders.TEIKI_KBN == '1'">{{$t('pt430.labels.selectPayment')}}</span>
                                                <button v-if="orders.AUTH_NOT_FLG == '1' && orders.TEIKI_KBN == '1'" type="button" @click="dochange(orders.ORDER_CD_TYPICAL)">{{$t('pt430.labels.change')}}</button>
                                            </td>
                                        </template>
                                        <!-- 配送業者 -->
                                        <template v-if="pt430Init.syukkaKanriFlg == 0">
                                            <td v-if="pt430Init.transCoDispFlg == 1" :aria-label="$t('pt430.labels.deliveryCompany')">
                                                <span v-if="orders.NOT_SYUKKA_FLG  != 1">{{orders.MARK_NM}}</span>
                                                <span v-else>－</span>
                                            </td>
                                            <td v-if="orders.ORDER_CNT > '1' && orders.HAISOU_CNT > 0">
                                                <span>{{$t('pt460.labels.multiShipments')}}</span> <br> <span>{{$t('pt460.labels.confirmDetScreen')}}</span>
                                            </td>
                                            <!-- 出荷日	 -->
                                            <td v-else :aria-label="$t('pt460.labels.shipDate')">
                                                <div v-if="orders.NOT_SYUKKA_FLG != 1 && orders.HAISOU_CNT == 1">
                                                    <span v-if="orders.SYUKKA_YMD == null || orders.SYUKKA_YMD == '0000/00/00'">&nbsp;</span>
                                                    <span v-else>{{orders.SYUKKA_YMD}}</span>
                                                </div>
                                                <div v-else>
                                                    <span>－</span>
                                                </div>
                                            </td>
                                            <!-- お問い合わせ番号 -->
                                            <td v-if="pt430Init.toiNoDispFlg == 1" :aria-label="$t('pt430.labels.optionLabel')">
                                                <div v-if="orders.NOT_SYUKKA_FLG  != 1">
                                                    <template v-if="isTuisekiLinkShow">
                                                        <a v-if=" orders.OKURINO_TYPICAL == null">&nbsp;</a>
                                                        <a v-else-if="orders.TRANS_CO_KBN == 'YA'" @click="selectTuisekiLinkUrlYA(orders.ORDER_CD_TYPICAL)">{{orders.OKURINO_TYPICAL}}</a>
                                                        <a v-else @click="selectTuisekiLinkUrl(orders.TRANS_CO_KBN,orders.OKURINO_TYPICAL)">{{orders.OKURINO_TYPICAL}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <span>{{orders.OKURINO_TYPICAL}}</span>
                                                    </template>
                                                </div>
                                                <div v-else>
                                                    <span>－</span>
                                                </div>
                                            </td>
                                            <!-- 配送状況 -->
                                            <td v-if="pt430Init.shipStatus == 1" :aria-label="$t('pt430.labels.shipStatus')">
                                                <div v-if="orders.HAISOU_CNT > 0">
                                                    <span v-if="orders.ORD_KAKUTEI_FLG != 1">
                                                        {{$t('pt430.labels.orderReception')}}
                                                    </span>
                                                    <span v-else-if="orders.ORD_KAKUTEI_FLG == 1 && orders.SHIP_KAN_FLG != 1">
                                                        {{$t('pt430.labels.shipPrepare')}}
                                                    </span>
                                                    <span v-else-if="orders.SHIP_KAN_FLG == 1 && orders.HAI_KAN_YMD == '0000/00/00'">
                                                        {{$t('pt430.labels.shipKan')}}
                                                    </span>
                                                    <span v-else-if="orders.HAI_KAN_YMD != null && orders.HAI_KAN_YMD != '0000/00/00'">
                                                        {{$t('pt430.labels.haiKan')}}
                                                    </span>
                                                    <span v-else>
                                                        {{$t('pt430.labels.statusErr')}}
                                                    </span>
                                                </div>
                                                <div v-else>
                                                    <span>－</span>
                                                </div>
                                            </td>
                                        </template>
                                        <!--担当者名-->
                                        <td v-if="pt430Init.tantoDispFlg == 1">
                                            <span>{{orders.TANTO_NM}}</span>
                                        </td>
                                        <!--店舗名-->
                                        <td v-if="pt430Init.storeDispFlg == 1">
                                            <span>{{orders.STORE_NM}}</span>
                                        </td>
                                        <!--納品書出力-->
                                        <td v-if="pt430Init.nohinsyoDispFlg == 1">
                                            <template v-if="!orders.GAIBU_ORDER_CD">
                                                <input v-if="orders.SHIP_KAN_FLG == 1" id="pt430-nohinsyo-button" 
                                                    @click="doDownloadPdf(orders.ORDER_NO,'4')" :value="$t('pt430.labels.nohinsyo')" type="button">
                                                <!--納品書出力日-->
                                                <span>{{orders.NOU_PRINT_YMD}}</span>
                                            </template>
                                        </td>
                                        <!--領収書出力-->
                                        <td v-if="pt430Init.ryousyuusyoDispFlg == 1">
                                            <template v-if="!orders.GAIBU_ORDER_CD">
                                                <input v-if="((orders.RYOUSYUU_PRINT_FLG == 2 && orders.KOBETU_RYOUSYUU_PRINT_FLG == 1) || orders.RYOUSYUU_PRINT_FLG == 1) && orders.CHK_FLG === 1 && orders.RECEIPT_KIN_SUMI > 0 && orders.SEIKYUU_KANRI_CD != ''" 
                                                    @click="setRyosyusyo(orders.ORDER_NO,buildName(orders.BILL_NM1, orders.BILL_NM2))" :value="$t('pt430.labels.ryousyuusyo')" type="button">
                                                <!--領収書出力日-->
                                                <a class="noteLink pt430hislink" @click="showHistory(orders.ORDER_CD_TYPICAL)">{{orders.RECEIPT_PRINT_YMD}}</a>
                                            </template>
                                        </td>
                                        <!-- 詳細 pt430Init-->
                                        <td class="cartLink">
                                            <router-link :to="generateLinkParams(10, pt430Init.orderHisDtl, { orderNo: orders.ORDER_NO, orderCdTypical: orders.ORDER_CD_TYPICAL, fBaFlg: orders.F_BA_FLG}, {ptPageNo: reqModel.pageNo,ptPageSize: reqModel.pageSize,sKbn: reqModel.searchKbn,rKbn: reqModel.rirekiKbn, ptOrderByType: reqModel.orderByType})">
                                                {{$t('pt430.labels.details')}}
                                            </router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </page-feed>
                    <!--戻るボタン-->
                    <div id="btn_roll3" v-if="pt430Init.backButtonFlg == 1">
                        <router-link  :to="generateLinkParams(81, pt430Init.myPage)" class="btnBack">
                            {{$t('common.buttons.return')}}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <!-- ※領収書出力情報※ -->
        <b-modal v-model="isModalRyosyusyo"
            size="md"
            centered
            :title="$t('pt430.labels.ryosyusyoTitle')"
            :footer-class="'mx-auto'">
            <div class="mx-auto">
                <div class="message" v-if="isModalRyosyusyoError">
                    <li class="text-danger"><a  style="font-size: 13px;"><span  class="font-weight-bold">領収書出力情報は必須です。</span></a></li>
                </div>
                <div class="row">
                    <div class="col-12 mb-1">
                        <div class="form-row with-label-background align-items-start">
                            <!-- 宛名 -->
                            <label class="col-4 col-form-label col-form-label-sm text-center text-danger font-weight-bold">
                                {{$t('pt430.labels.atena')}}
                            </label>
                            <div class="col p-0">
                                <div class="form-row">
                                    <div class="col">
                                        <input-check v-model="reqModel.atena" type="text"
                                            id="atena"  
                                            class="atenaInput"
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="form-row with-label-background align-items-start">
                            <!-- 但し書き -->
                            <label class="col-4 col-form-label col-form-label-sm text-center text-danger font-weight-bold">
                                {{$t('pt430.labels.description')}}
                            </label>
                            <div class="col p-0">
                                <div class="form-row">
                                    <div class="col">
                                        <input-check v-model="reqModel.description" type="text"
                                            id="description"  
                                            class="descriptionInput"
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer">
                <!-- 出力 -->
                <input @click="outputRyosyusyo()" :value="$t('pt430.buttons.output')" type="button">
            </div>
        </b-modal>

        <!-- ※領収書印刷履歴情報※ -->
        <b-modal v-model="isModalShowHistory"
            size="md"
            centered
            :title="$t('pt430.labels.printHisTitle')"
            :footer-class="'mx-auto'">
            <div class="mx-auto">
                <template v-for="(obj,index) in printHisList">
                    <div class="row" :key="index">
                        <div class="col-12 mb-1" v-if="index==0">
                            <div class="form-row with-label-background align-items-start">
                                <div class="col p-0">
                                    <div class="form-row">
                                        <div class="col-2">
                                            <span>{{$t('pt430.labels.printHisCol1')}}</span>
                                        </div>
                                        <div class="col">
                                            <span>{{$t('pt430.labels.printHisCol2')}}</span>
                                        </div>
                                        <div class="col">
                                            <span>{{$t('pt430.labels.printHisCol3')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-1">
                            <div class="form-row with-label-background align-items-start">
                                <div class="col p-0">
                                    <div class="form-row">
                                        <div class="col-2">
                                            <span>{{obj.ROW_NO}}</span>
                                        </div>
                                        <div class="col">
                                            <span>{{obj.RECEIPT_PRINT_YMD}}</span>
                                        </div>
                                        <div class="col">
                                            <span>{{obj.RECEIPT_PRINT_USER_NM}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div slot="modal-footer">
                <!-- 閉じる -->
                <input @click="isModalShowHistory = false" :value="$t('pt430.buttons.close')" type="button">
            </div>
        </b-modal>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import InputCheck from 'components/InputCheck';
import InputNumber from 'components/InputNumber';
import Message from 'components/MessageEcSite';
import PageFeed from '../commonParts/PageFeed';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
export default {
    /* 
    * Name of component
    */
    name: "PT430MemberOrderHisParts",
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare components
    */
    components:{
            InputCheck,
            InputNumber,
            Message,
            PageFeed,
            Breadcrumb
        },
    data() {
        return {
            isDisplay: false,
            noResult: false,
            rowIndex: null,
            isPagingDisplay:true,
            isLoading: false,
            siteFlg : null,
            isTuisekiLinkShow: false,
            isModalRyosyusyo: false,
            isModalRyosyusyoError: false,
            isModalShowHistory: false,
            printHisList: [],
            reqModel:{
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                rirekiKbn:'',
                searchKbn:'1',
                atena: '',
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 15,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            pt430Init: {
                orderNoDispFlg: 0,
                amountDispFlg: 0,
                transCoDispFlg: 0,
                toiNoDispFlg: 0,
                payDispFlg: 0,
                storeDispFlg: 0,
                tantoDispFlg: 0,
                backButtonFlg: 0
            },
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 0,
                toRecord: 10,
                pageSize: 10,
                pageNo: 1
            },
            dispPageSizeList:[
                {value: 5,text: "5行"},
                {value: 15,text: "15行"},
                {value: 30,text: "30行"},
                {value: 45,text: "45行"},
                {value: 50,text: "50行"},
                {value: 100,text: "100行"}
            ],
            SiteConstants: SiteConstants,
            iSearch:false,
            // for validate
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            jptuisekiLink: null,
            site: "",
            tnkDspKbn: null
        }
    },
    /*
    * 初期表示
    */
    mounted() {
        // Call API doInit
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            _this.pt430Init = _this.ptInitData;
            // 検索
            if (_this.iSearch == false){
                _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModels);
            }
        }else{
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_INIT, _this.reqModel).then(function(response) {
                _this.pt430Init = response.data;
                // 検索
                if (_this.iSearch == false){
                    _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModels);
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        // 未ログインの場合
        if(_this.pt430Init.status == 'NG'){
            // ログイン画面へ遷移
            const parameter = _this.generateLinkParams(18,_this.pt430Init.loginPage,{fromCart: 88});
            _this.$router.push(parameter);
        } else {
            // 検索処理
            _this.search();
        }
        _this.reqModel.description=_this.pt430Init.ryousyuuDesc;//但し書き初期値
    },
    /*
    * メソッド
    */
    methods: {
        /*
        * 検索処理
        */
        search: function() {
            var _this = this;
            // Clear msg validate
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt430');
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_SEARCH, _this.reqModel).then(function(response) {
                _this.pt430Init = response.data;
                if (response.data.list != null && response.data.list.length > 0) {
                    _this.pageFeedData.totalRecord = response.data.totalRecord;
                    _this.reqModel.totalRecord = response.data.totalRecord;
                    _this.pageFeedData.fromRecord = response.data.fromRecord;
                    _this.pageFeedData.toRecord = response.data.toRecord;
                    _this.pageFeedData.pageSize = response.data.pageSize;
                    _this.pageFeedData.pageNo = response.data.pageNo;
                    _this.tnkDspKbn = _this.pt430Init.list[0].TNK_DSP_KBN;
                     _this.isDisplay = true; 
                    _this.isPagingDisplay = true;
                    _this.noResult = false;
                    // 追跡リンク表示フラグ
                    if(_this.pt430Init.tuisekiLinkFlg == 1){
                        _this.isTuisekiLinkShow = true;
                    }else{
                        _this.isTuisekiLinkShow = false;
                    }
                }else{
                    _this.isDisplay = false;
                    _this.noResult = true;
                    _this.reqModel.totalRecord = 0;
                }

                _this.reqModel.rirekiKbn = _this.pt430Init.rirekiKbn;

                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt430');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * 領収書出力履歴検索
        */
        showHistory: function(orderCdTypical) {
            var _this = this;
            // Clear msg validate
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt430');
            _this.$emit("event-loading", true);
            var reqModel = {
                ajaxKbn: '1',
                orderCdTypical: orderCdTypical
            }
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_SEARCH, reqModel).then(function(response) {
                if (response.data.list != null && response.data.list.length > 0) {
                    _this.printHisList = response.data.list;
                    _this.isModalShowHistory = true;
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt430');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * ダウンロード pdf
        */
        doDownloadPdf: function(orderNo,printYoutoKbn) {
            var _this = this;
            _this.isLoading = true;

            _this.printData = {};
            _this.printData.orderNo = orderNo;
            _this.printData.printYoutoKbn = printYoutoKbn;
            _this.printData.atena = _this.reqModel.atena;
            _this.printData.description = _this.reqModel.description;
            //clear
            _this.reqModel.atena='';
            _this.reqModel.description='';
            
            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            if(appPath.startsWith('/')) {
                appPath = appPath.slice(1);
            }
            _this.printData.wfrBasePath = window.location.protocol + "//" + window.location.host + "/" +appPath;
            
            _this.$emit("event-loading", true);
            axios({url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_PRINT, method: "POST", responseType: "blob", data: _this.printData}).then(function(response) {
                var fileName = "";
                var disposition = response.headers["content-disposition"];
                if (disposition && disposition.indexOf("attachment") !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, "");
                }
                }
                if (/*@cc_on!@*/ false || !!document.documentMode) {
                window.navigator.msSaveBlob(new Blob([response.data]), fileName);
                } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                }
                _this.search();
                _this.$emit("event-loading", false);
            }).catch(async function(error) {
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            if (error.request.responseType === "blob") {
                                let responseObj = await error.response.data.text();
                                error.response.data = JSON.parse(responseObj);
                            }
                            var resultValid = common.excuteValidationEcSite(error, 'pt430');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }
                    }
                }
                _this.$emit("event-loading", false);
            });
        },

        /*
        * 領収書情報
        */
        setRyosyusyo: function(orderNo,billName) {
            this.ryosyusoPrintOrderNo = orderNo;
            this.reqModel.atena=billName;
            this.reqModel.description=this.pt430Init.ryousyuuDesc;//但し書き初期値
            this.isModalRyosyusyoError = false;
            this.isModalRyosyusyo = true;
        },
        outputRyosyusyo:function(){
            this.isModalRyosyusyoError = false;
            if(this.reqModel.atena == '' || this.reqModel.atena == null || this.reqModel.description == '' || this.reqModel.description == null){
                this.isModalRyosyusyoError = true;
                return;
            }
            this.isModalRyosyusyo = false;
            this.doDownloadPdf(this.ryosyusoPrintOrderNo,'241');
        },

        /**
         * 領収書名
         */
         buildName: function (name1, name2) {
            return [name1, name2]
                .filter(item => item && item !== 'null' && item !== 'undefined')
                .join(" ");
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            // マイメニュー画面へ遷移
            const parameter = _this.generateLinkParams(81,_this.pt430Init.myPage);
            _this.$router.push(parameter);
        },
        changeRirekiKbn: function(Kbn) {
            var _this = this;
            _this.reqModel.rirekiKbn = Kbn;
            _this.reqModel.pageNo = 1;
            _this.changeSearch(_this.reqModel.orderByType,_this.reqModel.pageSize,_this.reqModel.pageNo);
        },
        pt430search: function(skbn) {
            var _this = this;
            _this.reqModel.searchKbn = skbn;
            _this.reqModel.pageNo = 1;
            _this.changeSearch(_this.reqModel.orderByType,_this.reqModel.pageSize,_this.reqModel.pageNo);
        },
        // お支払い方法変更画面へ
        dochange: function(OrderCd) {
            var _this = this;
            var teikiFlg = '0';
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 82}, params: {orderNo: OrderCd,teikiFlg: teikiFlg}} );
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            var _this = this;
            _this.reqModel.pageSize = pageSize;
            _this.reqModel.pageNo = pageNo;
            _this.reqModel.orderByType = sortNo;
            var queryString = _this.getQueryString(pageSize, 'ptPageSize');
            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            // Vue Routerを用いてページ遷移
            location.href = appPath + this.$route.path + '?' + queryString;
        },
        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.reqModel.pageNo;
            query.ptPageSize = this.reqModel.pageSize;
            query.sKbn = this.reqModel.searchKbn;
            query.rKbn = this.reqModel.rirekiKbn;

            if(this.reqModel.orderByType != undefined) {
                query.ptOrderByType = this.reqModel.orderByType;
            }
            
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /* 
        * Function 
        * 追跡サイトへのリンク押下時処理
        */
        selectTuisekiLink: function(){
            //追跡サイトリンク
            window.open(this.pt430Init.tuisekiLinkUrl);
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        /* 
        * Function 
        * 追跡サイトへのリンク押下時処理
        */
        selectTuisekiLinkUrl: function(_transCoKbn,_okuriNo){
            if ('JP' == _transCoKbn) {
                var _jpLinkUrl = this.pt430Init.jptuisekiLink.replace('[1]',_okuriNo);
                window.open(_jpLinkUrl);
            } else if ('SG' == _transCoKbn) {
                var _sgLinkUrl = this.pt430Init.sgtuisekiLink.replace('[1]',_okuriNo);
                window.open(_sgLinkUrl);
            } 
        },
        /* 
        * Function 
        * ヤマト追跡サイトへのリンク押下時処理
        */
        selectTuisekiLinkUrlYA: function(orderCdTypical){
            var _this = this;
            // Clear msg validate
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt430');
            _this.$emit("event-loading", true);
            var reqModel = {
                ajaxKbn: '2',
                orderCdTypical: orderCdTypical
            }
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_SEARCH, reqModel).then(function(response) {
                _this.pt430Init.yatuisekiLink = response.data.yatuisekiLink;
                _this.pt430Init.yaTuisekiParam = response.data.yaTuisekiParam;
            
                let yaLinkUrl = '';
                let param = '';
                yaLinkUrl = _this.pt430Init.yatuisekiLink;
                param = _this.pt430Init.yaTuisekiParam;

                let _linkUrl = _this.settingUrl(yaLinkUrl,param);
                window.open(_linkUrl);

                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt430');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /**
         * Function settingUrl
         * @param {String} url, url get from DB
         * @param {String} param, param to binding for url
         * Replace param for url
         */
        settingUrl: function(url, param) {
            if(url) {
                if(url.indexOf("[1]") > -1) {
                    return url.replace("[1]", param);
                } else {
                    return url + param;
                }
            }
            return '';
        },
        /*
        * Function download
        * ダウンロード
        */
        download: function(){
            var _this = this;
            common.clearMessage(_this.listIdErr);
            //Call API to download files
            _this.isLoading = true;
            axios({
                    url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_DOWNLOAD_CSV,
                    method: 'POST',
                    responseType: 'blob', // important
                    data: _this.reqModel
                }
            )
            .then(function(response){
                var fileName = "";
                var disposition = response.headers['content-disposition'];
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) { 
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                if(/*@cc_on!@*/false || !!document.documentMode)
                {
                    window.navigator.msSaveBlob(new Blob([response.data]),fileName);
                }else{
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                _this.isLoading = false;
                common.clearMessage(_this.listIdErr);
            })
            .catch(function(error){
                var reader = new FileReader();
                reader.onload = function() {
                    if(error != null && error != undefined){
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var readerResult=JSON.parse(reader.result);
                                error.response.data.errorList=readerResult.errorList;
                                common.excuteValidation(error);
                            }else{
                                common.errorAPI(reader.result);
                            }
                        }
                    }
                }
                reader.readAsText(error.response.data);
                _this.isLoading = false;
            });
        },
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.sKbn != null){
                this.reqModel.searchKbn = this.queryData.sKbn;
            }
            if(this.queryData.rKbn != null){
                this.reqModel.rirekiKbn = this.queryData.rKbn;
            }
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
            if(this.queryData.ptOrderByType != null){
                this.reqModel.orderByType = this.queryData.ptOrderByType;
            }
        }
        //Get param from router when contructor this.
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.reqModel = Object.assign({}, _this.reqModel, data.requestBack);
            _this.iSearch=true;
        }
    },
}
</script>
